<template>
  <div class="help app-nav-wrap">
    <nav-bar :returnFunc="returnFunc" return-name="我的" current-name="帮我找货">
      <template #right>
        <p @click="showLayer = true">发布找货需求</p>
      </template>
    </nav-bar>

    <div class="app-nav-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="it in list" :key="it.id" @click="goDetail(it.id)">
            <p><i>产品名称：</i>{{ it.product_name }}</p>
            <p><i>需求内容：</i><span class="remark">{{ it.remark }}</span></p>
            <p><i>图片数量：</i>{{ it.image_count }}</p>
            <p><i>状态：</i><span class="status">{{ it.statusText }}</span></p>
            <p><i>提交时间：</i>{{ it.ctimeText }}</p>
            <p class="more"><span>查看详情</span></p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="showLayer" position="bottom" safe-area-inset-bottom>
      <help-find-goods-info @cancel="showLayer = false" @submit="onSubmitSuccess" />
    </van-popup>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import HelpFindGoodsInfo from '@/views/HelpFindGoodsInfo.vue';
import CommonService from '@/io/common.js';

export default {
  name: 'HelpFindGoods',
  components: { NavBar, HelpFindGoodsInfo },
  data() {
    return {
      showLayer: false,

      list: [],
      page: 1,
      pageSize: 10,
      total: 0,

      loading: false,
      finished: false,
      refreshing: false,

      isFetching: false, // ✅ 请求锁
    };
  },
  mounted() {
    this.initFirst();
  },
  methods: {
    returnFunc() {
      this.$router.push({ path: '/user' });
    },

    initFirst() {
      this.$toast.loading({ message: '加载中...', duration: 0 });
      this.resetList();

      // ✅ 这里手动触发一次加载
      this.loading = true;
      this.onLoad();
    },

    resetList() {
      this.page = 1;
      this.total = 0;
      this.list = [];
      this.finished = false;
      this.loading = false;
      this.isFetching = false;
    },

    onLoad() {
      if (this.finished || this.isFetching) {
        this.loading = false;
        return;
      }

      this.isFetching = true;

      CommonService.helpFindGoodsMyList(this.page, this.pageSize)
        .then(res => {
          const data = res.data || {};
          const rows = data.list || [];
          this.total = data.total || 0;

          const mapped = rows.map(r => ({
            ...r,
            statusText: this.statusText(r.status),
            ctimeText: this.formatTime(r.ctime),
          }));

          this.list = this.list.concat(mapped);
          this.page += 1;

          if (this.total === 0 || this.list.length >= this.total) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        })
        .finally(() => {
          this.isFetching = false;
          this.loading = false;
          this.refreshing = false;
          this.$toast.clear();
        });
    },

    onRefresh() {
      this.resetList();
      this.refreshing = true;
      this.loading = true;
      this.onLoad();
    },

    onSubmitSuccess() {
      this.showLayer = false;
      this.initFirst();
    },

    goDetail(id) {
      this.$router.push({ path: `/helpFindFood_detail/${id}` });
    },

    statusText(s) {
      const n = parseInt(s, 10);
      if (n === 0) return '待处理';
      if (n === 1) return '已联系';
      if (n === 2) return '已完成';
      if (n === 9) return '已关闭';
      return '未知';
    },

    formatTime(ts) {
      const t = parseInt(ts, 10);
      if (!t) return '';
      const d = new Date(t * 1000);
      const pad = v => (v < 10 ? `0${v}` : `${v}`);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
  },
};
</script>


<style lang="less" scoped>
@import '../assets/styles/tools.less';

.help {
  background-color: #F6F7F9;
  .iosBottom;

  .nav-bar {
    background-color: initial;
    .right-region {
      p {
        background-color: @color-primary;
        color: #FFFFFF;
        font-size: 22 * @r;
        width: 212 * @r;
        height: 42 * @r;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 21 * @r;
      }
    }
  }

  .item {
    background-color: #FFFFFF;
    margin: 28 * @r 44 * @r;
    padding: 40 * @r 54 * @r;
    border-radius: 16 * @r;

    p {
      font-size: 26 * @r;
      display: flex;

      & + p { margin-top: 18 * @r; }

      i { width: 130 * @r; }

      .remark {
        flex: 1;
        color: #2B2F36;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .status { color: #FDAB02; }
    }

    .more {
      justify-content: flex-end;
      span {
        color: @color-primary;
        font-weight: bold;
      }
    }
  }
}

.van-popup { height: 100%; }
</style>
